import React from "react";

const ImportExportTask = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg width={size} style={style} height={size} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg"
         className={`${className || ""}`} xmlnsXlink="http://www.w3.org/1999/xlink">
        <path
            className="u_fill"
            d="M15.765 0H0v32h25.777V9.7L15.766 0Zm-2.876 12.301 5.86 7.775h-3.644v6.138h-4.434v-6.138H7.028l5.861-7.775Zm3.391-3.103V2.912l6.489 6.286H16.28Z"
            fill={fill}
        />
    </svg>
);

export default ImportExportTask;


